// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import KnightAssistant from './components/KnightAssistant';
import './styles/KnightAssistant.css';
import Footer from './components/Footer';
import { SpeedInsights } from "@vercel/speed-insights/react"

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Experience />
              <Skills />
              <Blog />
              <KnightAssistant />
              <Footer />
              <SpeedInsights/>
            </>
          }
        />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </Router>
  );
}

export default App;
